import { UserExport } from '@pixacare/domain';

export type ExportsState = {
  exports: UserExport[];
  isLoaded: boolean;
};

export const initialExportsState: ExportsState = {
  exports: [],
  isLoaded: false,
};
